const routes = [
	{
		path: '/proyectos',
		component: () => import('@/views/dashboard/projects/List.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/agregar/proyecto',
		component: () => import('@/views/dashboard/projects/Add.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/proyecto/:slug',
		component: () => import('@/views/dashboard/projects/Edit.vue'),
		meta: {
			auth: true
		}
	}
];

export default routes;